import React from "react";
import "./index.css";

const Contact = () => {
  return (
    <div className="section contact">
      <div className="container-sm flex flexCol alignCenter">
        <div className="flex flexRow alignCenter flexWrap">
          <div className="contactCol relative">
            <h2 className="relative">Where to find us</h2>
            <p className="relative">
              <strong>Visit Us:</strong> 7251 Varna Avenue North <br />
              Hollywood, CA 91605 USA
            </p>
            <p className="relative">
              <strong>Opening Hours: </strong> Mon - Sat 08:00am - 6:00pm
            </p>
            <p className="relative">
              <strong>Call Us: </strong>
              <a href="tel:8188188408" target="_blank">
                (818) 818-8408
              </a>
            </p>
          </div>
          <div className="mapDiv">
            <iframe
              className="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31393.390554455116!2d-118.44276652247378!3d34.201980744071555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2972532598a4d%3A0xa36341e5fc2c970b!2sSilver%20Star%20Collision%20Center!5e0!3m2!1ses!2sar!4v1698250795160!5m2!1ses!2sar"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
